<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vnRktE/tc-custom/9780547819242.jpg?1718044270768" alt="This image is the cover for the book Best American Short Stories 2014, The Best American Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best American Short Stories 2014, The Best American Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“The literary ‘Oscars’ features twenty outstanding examples of the best of the best in American short stories.” — <i>Shelf Awareness for Readers</i></b></p><p><i>The Best American Short Stories 2014</i> will be selected by national best-selling author Jennifer Egan, who won the 2011 Pulitzer Prize and the National Book Critics Circle Award for fiction for <i>A Visit from the Goon Squad,</i> heralded by <i>Time</i> magazine as “a new classic of American fiction.” Egan “possesses a satirist’s eye and a romance novelist’s heart” (<i>New York Times Book Review</i>).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Egan, Heidi Pitlor
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f74e5fd